import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-merchant1",
  "use": "icon-merchant1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-merchant1\"><defs><style type=\"text/css\"></style></defs><path d=\"M526.671258 906.945024 366.50496 637.527962c0 0-173.408358 67.277312-233.568973 107.761357-60.166758 40.484045-86.761472 163.346227-86.761472 163.346227l962.660513 0c0 0-17.634304-115.704218-88.419328-163.346227-60.171878-40.484045-233.583309-107.761357-233.583309-107.761357L526.671258 906.945024zM526.671258 691.412173l-53.393203 53.876019 26.699162 53.885235-80.085197 107.77047 213.554334 0-80.082125-107.77047 26.69097-53.885235L526.671258 691.412173zM532.399923 73.714893c235.125453 0 235.535872 179.932058 235.535872 281.104282 0 101.173248-94.210458 289.163776-235.535872 289.38281C391.080653 644.432179 296.863027 455.992422 296.863027 354.819174 296.863027 253.64695 297.277542 73.714893 532.399923 73.714893z\" p-id=\"7020\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/merchant1.svg
// module id = mVBY
// module chunks = 60